/**
 * Shared control chrome for inputs and selects. The focus ring is part of the
 * component — never override it with `outline: none` at a call site.
 */
export const controlClass =
  'w-full rounded-lg border border-line-strong bg-surface-2 text-sm text-fg placeholder:text-fg-faint ' +
  'transition-colors duration-150 outline-none ' +
  'hover:border-line-hover focus:border-brand focus:ring-2 focus:ring-brand/35 ' +
  'disabled:cursor-not-allowed disabled:opacity-50 ' +
  'aria-[invalid=true]:border-danger aria-[invalid=true]:focus:ring-danger/30';
